import endpoints from "@/utils/constants";
import { apiHelper } from "@/utils/helpers";
import snakeToCamel from "../../../utils/SnakeToCamel";

const actions = {
  saveServiceRequest(context) {
    return new Promise((resolve, reject) => {
      apiHelper
        .call(
          "post",
          `${endpoints.BASE_URL}${endpoints.API.serviceRequests}`,
          context.state.serviceRequest
        )
        .then(res => {
          if (res.status === 201) {
            resolve(res.data);
          }
        })
        .catch(err => {
          reject(err);
        });
    });
  },

  getServiceRequestList(context, query) {
    const url = new URL(
      `${endpoints.BASE_URL}${endpoints.API.serviceRequests}`
    );
    if (query) {
      url.search = new URLSearchParams(query);
    }
    return new Promise((resolve, reject) => {
      apiHelper
        .call("get", url)
        .then(res => {
          if (res.status === 200) {
            context.commit("setServiceRequestList", res.data);
            resolve(res.data);
          }
        })
        .catch(err => {
          reject(err);
        });
    });
  },

  getServiceRequestListForPosChalan(context, query) {
    const url = new URL(
      `${endpoints.LARAVEL_BASE_URL}${endpoints.API.serviceRequests}/pos-chalan`
    );
    if (query) {
      url.search = new URLSearchParams(query);
    }
    return new Promise((resolve, reject) => {
      apiHelper
        .call("get", url)
        .then(res => {
          if (res.status === 200) {
            resolve(snakeToCamel(res.data));
          }
        })
        .catch(err => {
          reject(err);
        });
    });
  },

  fetchServiceRequest(context, serviceRequestId) {
    return new Promise((resolve, reject) => {
      apiHelper
        .call(
          "get",
          `${endpoints.BASE_URL}${endpoints.API.serviceRequests}/${serviceRequestId}`
        )
        .then(res => {
          if (res.status === 200) {
            context.commit("setServiceRequest", res.data);
            resolve(res.data);
          }
        })
        .catch(err => {
          reject(err);
        });
    });
  },

  // put request
  updateServiceRequest(context) {
    delete context.state.serviceRequest.externalGoodsMeta;
    if (context.state.serviceRequest.vendorId === "") {
      delete context.state.serviceRequest.vendorId;
    }
    if (context.state.serviceRequest.priority === "") {
      delete context.state.serviceRequest.priority;
    }
    if (context.state.serviceRequest.description === "") {
      delete context.state.serviceRequest.description;
    }
    return new Promise((resolve, reject) => {
      apiHelper
        .call(
          "put",
          `${endpoints.BASE_URL}${endpoints.API.serviceRequests}/${context.state.serviceRequest.serviceRequestId}`,
          context.state.serviceRequest
        )
        .then(res => {
          if (res.status === 200) {
            context.commit("setServiceRequest", res.data);
            resolve(res);
          }
        })
        .catch(err => {
          reject(err);
        });
    });
  },

  // patch request
  updateServiceRequestData(context, payload) {
    return new Promise((resolve, reject) => {
      apiHelper
        .call(
          "patch",
          `${endpoints.BASE_URL}${endpoints.API.serviceRequests}/${context.state.serviceRequest.serviceRequestId}`,
          payload
        )
        .then(res => {
          if (res.status === 200) {
            context.commit("setServiceRequest", res.data);
            resolve(res);
          }
        })
        .catch(err => {
          reject(err);
        });
    });
  },

  //generating sale for service request
  generateSale(context, payload) {
    return new Promise((resolve, reject) => {
      apiHelper
        .call(
          "get",
          `${endpoints.BASE_URL}${endpoints.API.serviceRequests}/${payload}/generate/sale`
        )
        .then(res => {
          if (res.status === 200) {
            context.commit("setServiceRequestSaleId", res.data.saleId);
            resolve(res);
          }
        });
    });
  },

  getStackedChartDataOfServiceRequest(_, query) {
    const url = new URL(
      `${endpoints.BASE_URL}${endpoints.API.serviceRequests}/stacked/bar/data`
    );
    if (query) {
      url.search = new URLSearchParams(query);
    }
    return new Promise((resolve, reject) => {
      apiHelper
        .call("get", url)
        .then(res => {
          if (res.status === 200) {
            resolve(res);
          }
        })
        .catch(err => {
          reject(err);
        });
    });
  },
  //generating vendor's invoice
  generateVendorsInvoiceNumber(context) {
    return new Promise((resolve, reject) => {
      apiHelper
        .call(
          "get",
          `${endpoints.BASE_URL}${endpoints.API.serviceRequests}/${context.state.serviceRequest.serviceRequestId}/generate/vendor/invoice`
        )
        .then(res => {
          if (res.status === 200) {
            context.commit("setServiceRequest", res.data);
            resolve(res);
          }
        });
    });
  },

  //patch request for external goods
  addExternalGoodsData(context, payload) {
    return new Promise((resolve, reject) => {
      apiHelper
        .call(
          "patch",
          `${endpoints.BASE_URL}${endpoints.API.serviceRequests}/${context.state.serviceRequest.serviceRequestId}/external/goods`,
          payload
        )
        .then(res => {
          context.commit("setServiceRequest", res.data);
          resolve(res);
        })
        .catch(err => {
          reject(err);
        });
    });
  },

  getServiceRequestAccountDetails(_, payload) {
    return apiHelper.call(
      "get",
      `${endpoints.BASE_URL}${endpoints.API.serviceRequests}/${payload}/account/details`
    );
  },

  getOpenCloseServiceRequestData(_, query) {
    const url = new URL(
      `${endpoints.BASE_URL}${endpoints.API.serviceRequests}/close-open/bar/data`
    );
    if (query) {
      url.search = new URLSearchParams(query);
    }
    return new Promise((resolve, reject) => {
      apiHelper
        .call("get", url)
        .then(res => {
          if (res.status === 200) {
            resolve(res);
          }
        })
        .catch(err => {
          reject(err);
        });
    });
  },

  getVendorInvoiceData(_, payload) {
    return new Promise((resolve, reject) => {
      apiHelper
        .call(
          "get",
          `${endpoints.BASE_URL}${endpoints.API.serviceRequests}/${payload}/vendor-invoice-data`
        )
        .then(res => {
          if (res.status === 200) {
            resolve(res.data);
          }
        })
        .catch(err => {
          reject(err);
        });
    });
  },

  getSaleInvoiceProducts(_, payload) {
    return new Promise((resolve, reject) => {
      apiHelper
        .call(
          "get",
          `${endpoints.BASE_URL}${endpoints.API.serviceRequests}/${payload}/products`
        )
        .then(res => {
          if (res.status === 200) {
            resolve(res.data);
          }
        })
        .catch(err => {
          reject(err);
        });
    });
  },

  /*service request logs*/
  getServiceRequestLogs(context, payload) {
    return new Promise((resolve, reject) => {
      apiHelper
        .call(
          "get",
          `${endpoints.BASE_URL}${endpoints.API.serviceRequestLogs}/${payload}`
        )
        .then(res => {
          if (res.status === 200) {
            context.commit("setServiceRequestLogs", res.data);
            resolve(res.data);
          }
        })
        .catch(err => {
          reject(err);
        });
    });
  },

  updateServiceRequestLog(context, payload) {
    return new Promise((resolve, reject) => {
      apiHelper
        .call(
          "patch",
          `${endpoints.BASE_URL}${endpoints.API.serviceRequestLogs}/${payload.logId}`,
          payload
        )
        .then(res => {
          if (res.status === 200) {
            resolve(res.data);
          }
        })
        .catch(err => {
          reject(err);
        });
    });
  },

  // Get service request stats
  getServiceRequestStats(context) {
    return new Promise((resolve, reject) => {
      apiHelper
        .call(
          "get",
          `${endpoints.LARAVEL_BASE_URL}${endpoints.API.serviceRequests}/stats`
        )
        .then(res => {
          if (res.status === 200) {
            context.commit("setServiceRequestStats", res.data);
            resolve(res.data);
          }
        })
        .catch(err => {
          reject(err);
        });
    });
  },

  // Generate bill request
  generateBillRequest(context, serviceRequestId) {
    return new Promise((resolve, reject) => {
      apiHelper
        .call(
          "post",
          `${endpoints.LARAVEL_BASE_URL}${endpoints.API.serviceRequests}/${serviceRequestId}/generate/bill`
        )
        .then(res => {
          if (res.status === 200 || res.status === 201) {
            resolve(res.data);
          }
        })
        .catch(err => {
          reject(err);
        });
    });
  }
};
export default actions;
